/**
 * 优惠活动首页
 */
import React, {Component, PropTypes} from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as activityAction from '../../actions/activityAction'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import {DOMAIN} from '../../constants/config';
import Loader from '../../components/icon/Loader.jsx'

class Activity extends React.Component {

  constructor(props) {
    super(props);
    this.handleClickActiveity = this.handleClickActiveity.bind(this);
    this.state = {
      activityId: this.props.match.params.id == 'list' ? null : this.props.match.params.id,
      url: null
    }
  }

  componentDidMount() {
    const __activity = this.props.__ACTIVITY.toJS();
    // 获取活动列表
    this.props.$$ACTIVITY.getActivityList();
    if (!__activity.list) return;
    // 设置默认值
    if (__activity.list.length > 0) {
      const activity = _.find(__activity.list, {id: parseInt(this.props.match.params.id)});
      if (activity) {
        this.handleClickActiveity(activity.id);
      }
    }

    // 自动设置高度
    this.iFrame = document.getElementById('FrameContainer');
    if (this.iFrame) {
      this.iFrame.onload = function () {
        this.iFrame.height = this.iFrame.contentWindow.document.body.clientHeight;
      }.bind(this);
    }
  }

  componentWillUnmout() {
    this.iFrame.onload = null;
  }

  componentDidUpdate() {
    this.iFrame = document.getElementById('FrameContainer');
    if (!this.iFrame) {
      return;
    }
    this.iFrame.onload = function () {
      this.iFrame.height = this.iFrame.contentWindow.document.body.clientHeight;
    }.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // 更新活动信息
    const __activity = nextProps.__ACTIVITY.toJS();
    if (!__activity.list) return;
    if (__activity.list.length == 0) {
      return;
    }
    // 如果第一次还没有值, 设置默认值
    if (this.state.url == null) {
      const activity = _.find(__activity.list, {id: parseInt(nextProps.match.params.id)});
      if (activity) {
        this.handleClickActiveity(activity.id);
        return;
      }
      this.handleClickActiveity(__activity.list[0].id);
      return;
    }
    // 如果直接通过URL改变活动ID
    if (this.state.activityId != nextProps.match.params.id) {
      const activity = _.find(__activity.list, {id: parseInt(nextProps.match.params.id)});
      // 如果没有找到这个活动
      if (!activity) {
        return;
      }
      this.handleClickActiveity(nextProps.match.params.id);
    }
  }

  // 点击活动
  handleClickActiveity(activityId) {
    this.setState({
      activityId: activityId,
      url: DOMAIN + 'activity/' + activityId
    })
  }

  render() {
    const __base = this.props.__BASE.toJS();
    const __activity = this.props.__ACTIVITY.toJS();
    return (
        <div>
          <RichHeader/>
          <SideBar/>
          {
            __activity.list ? (__activity.list.length > 0 ?
                <div id="contentBox" className="activity_main">
                  <div className="box-wrap over-flow-hidden">
                    <div className="right_meun" id="siderbar">
                      <ul>
                        {
                          __activity.list.map((item, index) => {
                            return <li
                                key={index}
                                className={item.id == this.state.activityId ? 'current' : ''}
                                onClick={this.handleClickActiveity.bind(this, item.id)}
                            >
                              <a>{item.title}</a>
                            </li>
                          })
                        }
                      </ul>
                    </div>
                    <div className="left_activity">
                      <iframe id='FrameContainer' scrolling='yes' src={this.state.url}/>
                    </div>
                  </div>
                </div> :
                <div className='activity_loaing'>
                  <Loader/>
                </div>) : null
          }
          <div className='mt30'/>
          <MainFooter/>
        </div>
    );
  }
}

reactMixin(Activity.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __ACTIVITY: state.activity
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$ACTIVITY: bindActionCreators(activityAction, dispatch)
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Activity)